export enum EsiaDataRequestSource {
  ProfileOrHome = 'profile_or_home',
  TelemedPay = 'telemed_pay',
}

export const ESIA_DATA_REQUEST_POPUP_DATA = {
  [EsiaDataRequestSource.ProfileOrHome]: {
    title: 'Добавьте проверенные данные из Госуслуг',
    subtitle: '',
    showRequiredPersonalData: true,
    steps: [
      'После записи на приём передадим ваши данные клинике-партнёру',
      'Клиника заранее подготовит договор — вам не нужно будет его заполнять',
      'В регистратуре останется подписать и оплатить —  всё займет пару минут',
    ],
  },
  [EsiaDataRequestSource.TelemedPay]: {
    title: 'Подтвердите личность через Госуслуги',
    subtitle: 'Перед оплатой нужно подтвердить вашу личность, чтобы врач мог провести консультацию и оформить медицинские документы.',
    showRequiredPersonalData: false,
    steps: [
      'Вы перейдёте в Госуслуги и подтвердите данные',
      'Мы проверим их — это займет до минуты',
      'Вы автоматически вернётесь к оплате',
    ],
  },
}
